import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { onboardingPath } from '../../constants';
import { useAuthContext } from '../../contexts/AuthContext';
import { useSessionContext } from '../../contexts/SessionContext';
import { useTrackOnboardingUsers } from '../../hooks/useTrackOnboardingUsers';

export default function AuthenticatedRoute() {
  const navigate = useNavigate();

  // Dependencies
  const { pathname, search } = useLocation();
  const { isAuthenticated, wasLoggedIn } = useAuthContext();
  const { me } = useSessionContext();
  const { userIsBeingOnboarded, stopTrackingUser } = useTrackOnboardingUsers();

  // Derived State
  const isBeingOnboarded = userIsBeingOnboarded(me?.email);
  const redirect = wasLoggedIn ? '' : `?redirect=${pathname}${search}`;

  useEffect(() => {
    if (!isAuthenticated) {
      navigate(`/login${redirect}`, { replace: true });
    }

    if (isAuthenticated && isBeingOnboarded && !redirect) {
      navigate(onboardingPath, { replace: true });
      stopTrackingUser(me?.email);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, isBeingOnboarded, me]);

  return <Outlet />;
}
